"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FieldHistoryImportError () {
        return FieldHistoryImportError;
    },
    get ImportFieldHistoryResponse () {
        return ImportFieldHistoryResponse;
    },
    get ValidateFieldHistoryImportResponse () {
        return ValidateFieldHistoryImportResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _generic = require("../generic");
const FieldHistoryImportError = _models.FieldHistoryImportErrorSchema;
const ValidateFieldHistoryImportResponse = _zod.z.object({
    success: _zod.z.boolean(),
    entryCount: _zod.z.number().int().nonnegative(),
    employeeCount: _zod.z.number().int().nonnegative(),
    /** Capped at `MAX_FIELD_HISTORY_IMPORT_ERRORS`. Compare against `totalErrorCount` to detect truncation. */ errors: _zod.z.array(FieldHistoryImportError),
    totalErrorCount: _zod.z.number().int().nonnegative()
});
const ImportFieldHistoryResponse = _generic.GenericTaskIdResponse;
